import React from "react";
import { FiMail, FiPhone, FiMapPin, FiMessageCircle } from "react-icons/fi";

const Contact: React.FC = () => {
  const contactInfo = [
    {
      icon: <FiMail className="w-6 h-6" />,
      title: "Email",
      value: "rafaelalvarezcorp@gmail.com",
      link: "mailto:rafaelalvarezcorp@gmail.com",
    },
    {
      icon: <FiPhone className="w-6 h-6" />,
      title: "Teléfono",
      value: "+52 999 242 7569",
      link: "tel:+529992427569",
    },
    {
      icon: <FiMapPin className="w-6 h-6" />,
      title: "Ubicación",
      value: "Mérida, Yucatán, México",
      link: "https://maps.google.com/?q=Mérida,Yucatán,México",
    },
    {
      icon: <FiMessageCircle className="w-6 h-6" />,
      title: "WhatsApp",
      value: "+52 999 242 7569",
      link: "https://wa.me/529992427569",
    },
  ];

  return (
    <section id="contacto" className="py-12 md:py-20 bg-white">
      <div className="container px-4 mx-auto max-w-6xl">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-12">
          Contacto
        </h2>

        {/* Grid principal */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Información de contacto */}
          <address className="not-italic space-y-6">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-800">
              Información de Contacto
            </h3>
            <p className="text-gray-600 leading-relaxed text-base md:text-lg">
              Estoy interesado en nuevas oportunidades y proyectos desafiantes.
              Si tienes alguna pregunta o quieres colaborar, no dudes en
              contactarme.
            </p>

            <div className="space-y-4">
              {contactInfo.map((contact, index) => (
                <a
                  key={index}
                  href={contact.link}
                  target={contact.link.startsWith("http") ? "_blank" : "_self"}
                  rel={contact.link.startsWith("http") ? "noopener noreferrer" : undefined}
                  className="block group"
                >
                  <div className="flex items-center p-4 bg-gray-50 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1">
                    <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0 text-primary-600 group-hover:bg-primary-600 group-hover:text-white transition-colors">
                      {contact.icon}
                    </div>
                    <div className="flex-1">
                      <h4 className="font-semibold text-gray-800 mb-1 text-lg">
                        {contact.title}
                      </h4>
                      <p className="text-primary-600 group-hover:text-primary-800 transition-colors text-sm md:text-base break-all">
                        {contact.value}
                      </p>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </address>

        
        </div>

        {/* Redes Sociales (puedes expandir después) */}
        <div className="mt-16 text-center">
          <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-6">
            Sígueme en Redes Sociales
          </h3>
          <div className="flex justify-center space-x-6">
            {/* Ejemplo de íconos sociales */}
            {/* <a href="#" className="text-gray-600 hover:text-primary-600 transition">
              <FiInstagram className="w-6 h-6" />
            </a> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;